import { useFormContext, useFormField } from '@calendly/form'
import { templateLength } from '@calendly/rich-text-editor'
import { ContextualBanner } from '@calendly/ui/components/contextual-banner'
import { AlertWarningCircleIcon } from '@calendly/ui/components/icons'
import { useState, useCallback } from 'react'

import { MAX_SMS_BODY_LENGTH } from 'services/workflows/actions'

import { BodyDetailsField } from './body_details_field'
import { PlainTextField } from './plain_text_field'
import { FieldBlock } from './styles'

export const isSmsNotification = (kind) => kind === 'invitee_sms_reminder'

export const SmsBodyField = (props) => {
  const [fieldProps, meta] = useFormField(props)
  const { setFieldValue, setTouched } = useFormContext()
  const [counter, setCounter] = useState(null)
  const bodyError = meta.error

  const { value: currentValue } = fieldProps
  const defaultBody = props.defaultContent
  const isCustom = defaultBody !== currentValue.plainText

  const onChange = useCallback((value) => {
    if (value.source !== 'user') {
      return
    }

    setFieldValue(props.name, value, false)

    if (!meta.touched) {
      setTouched({ [props.name]: true }, false)
    }

    if (value.source === 'user') {
      setCounter(templateLength(value))
    }
  }, [meta.touched, props.name, setFieldValue, setTouched])

  return (
    <>
      <FieldBlock data-component="body_field_block">
        <PlainTextField
          {...props}
          {...fieldProps}
          hasError={Boolean(bodyError)}
          onChange={onChange}
        />
        {bodyError ? (
          <ContextualBanner
            variant="danger"
            icon={AlertWarningCircleIcon}
            spacingTop={16}
            spacingBottom={16}
          >
            {bodyError}
          </ContextualBanner>
        ) : null}
      </FieldBlock>
      {isCustom && (
        <BodyDetailsField counter={counter} maxLength={MAX_SMS_BODY_LENGTH} />
      )}
    </>
  )
}
